import React from 'react'

import InfoCircleTooltip from 'components/InfoCircleTooltip'

import classes from './Heading.module.scss'

/** @type {import("./types").default} */
const Heading = () => (
  <InfoCircleTooltip
    className={classes.startingPrice}
    label="Starting price"
    title="Prices may vary depending on the number of users and features."
  />
)

export default Heading
